import { render } from "./personalAccessoriesaddPost.vue?vue&type=template&id=2f2eeccc&scoped=true"
import script from "./personalAccessoriesaddPost.vue?vue&type=script&lang=js"
export * from "./personalAccessoriesaddPost.vue?vue&type=script&lang=js"

import "./personalAccessoriesaddPost.vue?vue&type=style&index=0&id=2f2eeccc&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2f2eeccc"]])

export default __exports__